// @flow
import * as React from 'react';

import { RESORT_RESTAURANTS } from 'Client/cms/toolkit/constants';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductCatering } from 'Components/widgets/product-catering/ProductCatering';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

import {
  productRestaurantsResolver,
  type CMSProps,
  type GQLProps,
} from './productRestaurants.resolver';

type LineProps = CMSProps & GQLProps;

const ProductRestaurantsLine = ({
  config = {},
  restaurants: { introduction, restaurantsList = [] },
  title,
}: LineProps) => {
  const intros = introduction
    ? [
        {
          description: introduction.description,
        },
      ]
    : [];

  const list = restaurantsList.map(restaurant => {
    const [image] = restaurant.images;
    return { ...restaurant, image };
  });
  return (
    <SiteContainer className="Line">
      <LineTitle>{title}</LineTitle>
      <ProductCatering
        productCateringTitle={title}
        intros={intros}
        list={list}
        seeLessLabel={config.common.loadLess}
        seeMoreLabel={config.common.viewMore}
      />
    </SiteContainer>
  );
};

export const productRestaurantsDescriptor = {
  name: RESORT_RESTAURANTS,
  component: ProductRestaurantsLine,
  resolve: productRestaurantsResolver.resolve,
};
